<template>
  <v-card color="secondary" class="mt-1" flat>
    <v-card-title>
      <span class="subtitle-1">
        Callsheet analysis detail
      </span>
      <v-spacer></v-spacer>
      <v-btn icon  @click="showContent=!showContent">
        <v-icon :color=showIconColor>{{showIcon}}</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text v-if="showContent">
      <span v-if="item">
        <v-simple-table >
          <template v-slot:default>
            <tbody>
              <tr>
                <td :colspan="colspan" class="caption" style="padding-top:10px;">Profession details</td>
              </tr>

              <tr>
                <td >Profession</td>
                <td >{{item.profession}}</td>
              </tr>

              <tr>
                <td :colspan="colspan" class="caption" style="padding-top:10px;">Company details</td>
              </tr>

              <tr>
                <td >Company</td>
                <td>{{item.company}}</td>
              </tr>

              <tr>
                <td>Role</td>
                <td>{{item.profession}}</td>
              </tr>

              <tr>
                <td :colspan="colspan" class="caption" style="padding-top:10px;">Contact details</td>
              </tr>

              <tr>
                <td >Email</td>
                <td>{{item.email}}</td>
              </tr>

              <tr>
                <td>Phone</td>
                <td>{{item.phone}}</td>
              </tr>

              <tr>
                <td>Mobile</td>
                <td>{{item.mobile}}</td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>

      </span>
      <span v-else>
        No call sheet analysis found
      </span>
    </v-card-text>
  </v-card>


</template>
<script>
import { getIconColor, getIcon } from '@/js/store'

export default {
  props: {
    item: Object
  },
  methods: {
    expandItem () {
      this.$emit('expand')
    }
  },
  data: () => ({
    showContent: false,
    limit: 20
  }),
  computed: {
    colspan () {
      return 2
    },
    showIcon () {
      return getIcon(this.showContent ? 'hide' : 'show')
    },
    showIconColor () {
      return getIconColor(this.showContent ? 'hide' : 'show')
    },
    itemName () {
      return this.item.person
    },
    itemRole () {
      return this.item.profession
    }
  }
}
</script>
